module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UTxOTs/tc-custom/9781398433502.jpg?1705688300456",
      "alt": "This image is the cover for the book After the Applause"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("After the Applause\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("'Blurb' Contained within, Poetic words, some grim, of my recent experiences, during these times mysterious, of love and loyalty, and life’s’ great frailties, words of understanding, and observations on society, I share all this with you, humor, tears, happiness, fears, nakedly I bear my soul, for you to read, because we all need to forgive ourselves in times like these.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Andrew Ridgway\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Once upon a time Andrew Ridgway, who was born in 1973 wanted to be a writer. But life had other ideas, and so for over 21 years he has worked as a theater nurse."), _c('br'), _vm._v("In his first published book, which collects together his humanistic themed poetry Andrew is processing difficult events in his life. These include recent experiences being re-deployed to his hospital’s intensive care unit during the Covid 19 pandemic. "), _c('br'), _vm._v("He is currently working on a second book of poetry based on love and relationships.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0